import React, { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { PrizeColumn } from './PrizeColumn'

// Helper function to shuffle array
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const PrizeDisplay = ({ prizes, isVisible }) => {
  const [columns, setColumns] = useState([])

  useEffect(() => {
    console.log("Prizes received in PrizeDisplay:", prizes)
    const shuffledPrizes = shuffleArray(prizes);
    const columnCount = 4
    const itemsPerColumn = Math.ceil(shuffledPrizes.length / columnCount)
    const newColumns = Array.from({ length: columnCount }, (_, i) => 
      shuffledPrizes.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn)
    )
    console.log("Columns created:", newColumns)
    setColumns(newColumns)
  }, [prizes])

  const backgroundVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { duration: 0.5 }
    },
    exit: { 
      opacity: 0,
      transition: { duration: 0.5, delay: 0.2 }
    }
  }

  const contentVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { duration: 1, delay: 1 }
    },
    exit: { 
      opacity: 0,
      transition: { duration: 0.4 }
    }
  }

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed inset-0 z-50 overflow-hidden font-roboto"
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <motion.div 
            className="absolute inset-0 bg-gradient-to-br from-[#163456] to-[#2B657B]"
            variants={backgroundVariants}
          >
            {/* Animated background patterns */}
            <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_50%_50%,#163456,#2B657B)]" />
            <div className="absolute inset-0 opacity-20 bg-[linear-gradient(45deg,transparent_25%,#163456_50%,transparent_75%)]" />
          </motion.div>

          <motion.div 
            className="relative w-full h-screen px-2 sm:px-4 flex items-center overflow-hidden"
            variants={contentVariants}
          >
            <div className="flex justify-between gap-2 sm:gap-4 w-full h-[120vh] -my-[10vh]">
              {columns.map((columnPrizes, index) => (
                <div key={index} className="flex-1 h-full overflow-hidden">
                  <PrizeColumn 
                    prizes={columnPrizes} 
                    direction={index % 2 === 0 ? 'up' : 'down'} 
                    speed={index + 1}
                  />
                </div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
